// extracted by mini-css-extract-plugin
export default {"logo":"RexptLogo_logo__QOlU1"};